import { point } from "./cardinal.js";
export function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function () {
        this._line = 0;
    },
    areaEnd: function () {
        this._line = NaN;
    },
    lineStart: function () {
        this._x0 = this._x1 = this._x2 =
            this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function () {
        if (this._line || (this._line !== 0 && this._point === 3))
            this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function (x, y) {
        x = +x, y = +y;
        switch (this._point) {
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3: this._point = 4; // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
export default (function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function (tension) {
        return custom(+tension);
    };
    return cardinal;
})(0);
